<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/TBOX2/TBOX2.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">第二代5G车载通信单元（双卡双待）</div>
                <div class="detail-banner-desc">
                    集成车路协同（V2X）功能，实现车 - 路 - 云协同，支持多模多频GNSS，实现厘米级定位；<br />
                    内核数灵活可配（2/3/4）， 算力可达21.6KDMIPS；网络下行速率最高可达2.5Gbps、上行速率可达625Mbps，支持C-V2X 16个场景（可致34个）；<br />
                    提供便利服务：30+远程控制和数据上报功能, 为用户带来便利，同时提升原始设备制造商（OEMs）的运营效率；实现ECALL、IBCall为车主及乘客安全提供保障；<br />
                    创新承诺：T-Box 系列体现了我们对先进连接技术、安全保障及以用户为中心的解决方案的不懈追求，助力实现更智能、更安全的出行。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            网络：支持2/3/4/5G（NR）和C-V2X 通信,最大通信速率：2.5G (DL)/ 625M(UL)bps<br />
                        </div>
                        <div>
                            标准：支持3GPP Rel-16 Sub-6SA/NSA100MHz<br />
                        </div>
                        <div>
                            平台化设计：兼容5G/5G+DSDS/5G+V2X/5G+DSDS+V2X设计<br />
                        </div>
                        <div>
                            导航：集成多模多频导航模组，外置北斗定位芯片，支持北斗独立、北斗优先、北斗单模<br />
                        </div>
                        <div>
                            通讯：车用以太网总线架构，以太网支持DOIP，SOMEIP协议，支持1000 BASE T1（兼容100 BASE T1）<br />
                        </div>
                        <div>
                            其他：FOTA，双卡双待
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX2/TBOX2-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Quad core ARM Cortex-A55</div>
                                    <div class="k">CPU core</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">up to 2.0 GHz</div>
                                    <div class="k">CPU frequency</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">21.6K DMIPS</div>
                                    <div class="k">Computing Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1000 Base-T1</div>
                                    <div class="k">以太网</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Sub-dm</div>
                                    <div class="k">定位精度</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">4nm</div>
                                    <div class="k">制程</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Up to 2.5 G / 625M bps</div>
                                    <div class="k">DL/UL Data rate</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">8Gb LPDDR4X+8Gb Nand Flash</div>
                                    <div class="k">存储器</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Up to 2.5 G / 625M bps</div>
                                    <div class="k">DL/UL Data rate</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">8Gb LPDDR4X+8Gb Nand Flash</div>
                                    <div class="k">存储器</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/TBOX2/TBOX2-1.jpg" alt="200-1-02">
                    </div>
                </div> -->

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '第二代5G车载通信单元（双卡双待） - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/TBOX2.html'
};

import { createApp } from 'vue';
import App from './TBOX2.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./TBOX2.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
